import {API_GET_NOTIFICATIONS_UNREAD} from "../constants";

const state = {
    notifications : []
}
const mutations = {
    SET_NOTIFICATIONS : (state, payload) => {
        state.notifications = payload
    },
    READ_NOTIFICATIONS(state, id) {
        state.notifications = state.notifications.filter(i => i.id !== id)
    }
}
const getters = {
    NOTIFICATIONS : state => {
        return state.notifications;
    }
}
const actions = {
    async GET_NOTIFICATIONS({commit}) {
        await api.call('get', API_GET_NOTIFICATIONS_UNREAD)
            .then(data => commit('SET_NOTIFICATIONS', data.data))
            .catch(e => console.log(e))
    }
}

export default {
    state, getters, mutations, actions
}
